<template>
  <el-container class="layout-container">
    <el-aside width="200px" class="sidebar">
      <div class="logo">
        <h2>发单小助手管理后台</h2>
      </div>
      <el-menu
        :default-active="activeMenu"
        router
        class="sidebar-menu"
      >
        <el-menu-item index="/dashboard">
          <el-icon><DataAnalysis /></el-icon>
          <span>数据总览</span>
        </el-menu-item>
        <el-menu-item index="/websocket-monitor">
          <el-icon><Connection /></el-icon>
          <span>WebSocket监控</span>
        </el-menu-item>
        <el-menu-item index="/payment-history">
          <el-icon><Wallet /></el-icon>
          <span>支付历史</span>
        </el-menu-item>
        <el-menu-item index="/apps">
          <el-icon><Grid /></el-icon>
          <span>App管理</span>
        </el-menu-item>
        <el-menu-item index="/groups">
          <el-icon><ChatLineRound /></el-icon>
          <span>群组管理</span>
        </el-menu-item>
        <el-menu-item index="/industries">
          <el-icon><Shop /></el-icon>
          <span>行业配置</span>
        </el-menu-item>
        <el-menu-item index="/provinces">
          <el-icon><MapLocation /></el-icon>
          <span>省份配置</span>
        </el-menu-item>
        <el-menu-item index="/users">
          <el-icon><User /></el-icon>
          <span>用户查看</span>
        </el-menu-item>
        <el-menu-item index="/messages">
          <el-icon><Message /></el-icon>
          <span>消息查看</span>
        </el-menu-item>
        <el-menu-item index="/system-notifications">
          <el-icon><Bell /></el-icon>
          <span>系统通知</span>
        </el-menu-item>
        <el-menu-item index="/reports">
          <el-icon><Warning /></el-icon>
          <span>举报管理</span>
        </el-menu-item>
        <el-menu-item index="/media-checks">
          <el-icon><Warning /></el-icon>
          <span>内容风控</span>
        </el-menu-item>
        <el-menu-item index="/merchant-cooperation">
          <el-icon><Shop /></el-icon>
          <span>商户合作</span>
        </el-menu-item>
        <el-menu-item index="/discover-management">
          <el-icon><Document /></el-icon>
          <span>发现管理</span>
        </el-menu-item>
        <el-menu-item index="/service-channel-subscribers">
          <el-icon><User /></el-icon>
          <span>服务号粉丝查询</span>
        </el-menu-item>
        <el-menu-item index="/template-messages">
          <el-icon><Message /></el-icon>
          <span>模板消息记录</span>
        </el-menu-item>
        <el-menu-item index="/knowledge-base">
          <el-icon><Document /></el-icon>
          <span>知识库管理</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="header">
        <div class="header-right">
          <el-button type="danger" size="small" @click="handleLogout">退出登录</el-button>
        </div>
      </el-header>
      <el-main class="main-content">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessageBox } from 'element-plus'
import { DataAnalysis, Grid, ChatLineRound, User, Message, Bell, Warning, Shop, MapLocation, Connection, Wallet, Document } from '@element-plus/icons-vue'

const route = useRoute()
const router = useRouter()

const activeMenu = computed(() => route.path)

const handleLogout = () => {
  ElMessageBox.confirm('确定要退出登录吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    localStorage.removeItem('admin_token')
    router.push('/login')
  }).catch(() => {})
}
</script>

<style scoped>
.layout-container {
  height: 100vh;
}

.sidebar {
  background-color: #304156;
  color: #fff;
}

.logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #434a55;
}

.logo h2 {
  color: #fff;
  font-size: 18px;
  margin: 0;
}

.sidebar-menu {
  border: none;
  background-color: #304156;
}

.sidebar-menu .el-menu-item {
  color: #bfcbd9;
}

.sidebar-menu .el-menu-item:hover {
  background-color: #263445;
}

.sidebar-menu .el-menu-item.is-active {
  background-color: #409eff;
  color: #fff;
}

.header {
  background-color: #fff;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 20px;
}

.main-content {
  background-color: #f0f2f5;
  padding: 20px;
}
</style>

